import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ContainerMain, BrandingTabContainer, BrandingTab } from '../common/commonStyles';
import SnapShot from './snapShot'
import Analytics from './analytics'
import Insights from './insight'
import Performance from './performance'
import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';
import CompletedChallengeV2 from './complete'
import Library from './library'

const RecognitionMain = ({ history, yearList, selectedYearInfo, companyInfo, challengesData }) => {
  let date = new Date();
  const filterOption = ["Monthly", "Quarterly", "Yearly"];
  date.setFullYear(date.getFullYear() - 1);
  const [activeTab, setActiveTab] = useState(1);
  const [selectedYear, setSelectedYear] = useState("2025");
  const yearOptions = ["2025","2024","2023"];
  const [filterOptions, setFilterOptions] = useState(filterOption);
  const [timeInterval, setTimeInterval] = useState("Monthly");

  useEffect(()=>{
    if(history.location.state){
      setActiveTab(history.location.state.activeTab)
    }
  },[])

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    if(tabIndex === 2||tabIndex === 3||tabIndex === 4){
      setFilterOptions(filterOption);
      setTimeInterval("Monthly");
    }
  };

  let getColor = "rgba(243, 122, 101, 1)"

  const tabs = [
    { id: 1, label: 'Snapshot' },
    { id: 2, label: 'Analytics' },
    { id: 3, label: 'Insights' },
    { id: 4, label: 'Performance' },
    { id: 5, label: 'Completed' },
    // { id: 6, label: 'Library' }
  ];

  return (
    <> 
      <ContainerMain>
        <div className='content-wrap'>
          <BrandingTabContainer isCompare={"0px"}>
            <div className='wrapper'>
              {tabs.map((tab) => (
                <BrandingTab
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  active={activeTab === tab.id}
                  background={getColor ? getColor : "#0b4170"}
                >
                  {tab.label}
                </BrandingTab>
              ))}
            </div>
            <div className='rightSection'>
              <div style={{marginLeft:"10px"}}>
                {activeTab === 1||activeTab === 5 ? (
                  <CommonFilterDropdown
                    options={yearOptions}
                    selectedOption={selectedYear}
                    setSelectedOption={setSelectedYear}
                    dropdownHeight={"auto"}
                  />
                ):
                  <CommonFilterDropdown
                    options={filterOptions}
                    selectedOption={timeInterval}
                    setSelectedOption={setTimeInterval}
                    dropdownHeight={"auto"}
                  />
                }
              </div>
            </div>
          </BrandingTabContainer>
          {activeTab===1&&<SnapShot companyid={companyInfo?.id} history={history}/>}
          {activeTab===2&&<Analytics getColor={getColor}/>}
          {activeTab===3&&<Insights getColor={getColor} selectedFilter={timeInterval}/>}
          {activeTab===4&&<Performance selectedFilter={timeInterval}/>}
          {activeTab===5&&<CompletedChallengeV2
            history={history}
            challengesData={challengesData}
            yearList={yearList}
            selectedYearInfo={selectedYearInfo}
            companyId={companyInfo?.id}
            selectedOption={selectedYear}
          />}
          {activeTab===6&&<Library getColor={getColor} history={history}/>}
        </div>
      </ContainerMain>
    </>
  );
};

RecognitionMain.propTypes = {
  companyInfo: PropTypes.object.isRequired,
  companyId: PropTypes.number,
  companyBrandingDetails: PropTypes.object,
  yearList: PropTypes.array,
  history:PropTypes.object,
  selectedYearInfo: PropTypes.number,
  challengesData: PropTypes.array,
};

const mapStateToProps = (state) => ({
  companyBrandingDetails: state.wellnessDashboard.companyBrandingDetails,
  selectedYearInfo: state.companyDashboard.selectedYearInfo
});

export default connect(mapStateToProps, null)(RecognitionMain);